import { mapState } from 'vuex'

/** Returns a mix-in for reloading a view or list based on the global 'shouldReload' state or the router query state */
export default loadActionName => ({
  computed: {
    ...mapState(['shouldReload'])
  },
  watch: {
    shouldReload(isTrue) {
      if (isTrue) this[loadActionName](this.$route.query)
    },
    '$route.query': {
      handler(query) {
        this[loadActionName](query)
      },
      immediate: true
    }
  }
})
